import { render, staticRenderFns } from "./ApiDocumentation.vue?vue&type=template&id=2c1323e1&scoped=true"
import script from "./ApiDocumentation.vue?vue&type=script&lang=js"
export * from "./ApiDocumentation.vue?vue&type=script&lang=js"
import style0 from "./ApiDocumentation.vue?vue&type=style&index=0&id=2c1323e1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1323e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1323e1')) {
      api.createRecord('2c1323e1', component.options)
    } else {
      api.reload('2c1323e1', component.options)
    }
    module.hot.accept("./ApiDocumentation.vue?vue&type=template&id=2c1323e1&scoped=true", function () {
      api.rerender('2c1323e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/developer-portal/views/ApiDocumentation.vue"
export default component.exports